import { render, staticRenderFns } from "./socialAllowance.vue?vue&type=template&id=9975d000&scoped=true"
import script from "./socialAllowance.vue?vue&type=script&lang=js"
export * from "./socialAllowance.vue?vue&type=script&lang=js"
import style0 from "./socialAllowance.vue?vue&type=style&index=0&id=9975d000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975d000",
  null
  
)

export default component.exports